import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "video" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "tool fa fa-spinner fa-spin"
}
const _hoisted_4 = {
  key: 2,
  class: "tool fa fa-spinner fa-spin"
}
const _hoisted_5 = { class: "video-mask video-mask-black" }
const _hoisted_6 = { class: "video-mask video-mask-white" }
const _hoisted_7 = {
  key: 0,
  class: "post-play-view"
}
const _hoisted_8 = {
  key: 0,
  class: "overlay2"
}
const _hoisted_9 = { class: "row1" }

import { useMoviePlayerVideo } from 'src/components/lib/MoviePlayer/useMoviePlayerVideo';
import type { MoviePlayerVideoProps, MoviePlayerVideoEmit } from 'src/models/moviePlayer';


export default /*@__PURE__*/_defineComponent({
  __name: 'MoviePlayerVideo',
  props: {
    vid: { default: '' },
    playerType: {},
    isCurrentMovieReady: { type: Boolean },
    isDownloadingMovieFile: { type: Boolean },
    isDownloadingScreenshot: { type: Boolean },
    currentMovie: { default: null },
    movieFileUrl: { default: null },
    videoControlProperties: { default: () => ({
    playSpeed: 1.0,
    volume: 0,
    // playingだけでは、falseのままでは再実行されないため、
    // 元の動きと異なりますので、playとpause両方でコントロールする。
    play: 0,
    pause: 0,
    tickMsec: 0,
    reset: 0,
    loadMovie: 0, // 動画再生中に複数回切り替える場合があるため、数字で管理する。
    isPlayBackward: false,
  }) },
    isFront: { type: Boolean },
    disableVolume: { type: Boolean },
    syncCurrentTime: { default: null },
    titleBarTexts: { default: () => ({ dateDisp: '' }) },
    hasContinuedMovies: { type: Boolean },
    isMovieEnded: { type: Boolean }
  },
  emits: ["play-previous-movie", "play-next-movie", "seek-change", "tick-backward", "tick-forward", "play", "pause", "playmode-change", "prepared", "vjs-time-update", "vjs-error", "loaded-data", "start-download-screenshot", "finish-download-screenshot", "start-download-movie-file", "finish-download-movie-file", "play-continued-movies"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const {
  state,
  shouldShowPostPlayView,
  prepareVideojs,
  onVideoToolboxAreaClicked,
  enterFullScreen,
  takeScreenshot,
  getScreenshotBlob,
  tryDownload,
  playContinuedMovies,
  changeVjsPlayMode,
} = useMoviePlayerVideo(props, emit);

__expose({
  prepareVideojs,
  getScreenshotBlob,
  changeVjsPlayMode,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      id: __props.vid,
      class: "video-js vjs-fluid",
      crossorigin: "",
      playsinline: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: "glass-layer",
      onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_unref(state).showVideoToolbox = true)),
      onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_unref(state).showVideoToolbox = false))
    }, [
      (_unref(state).isActiveVjsId && _unref(state).showVideoToolbox)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "video-toolbox",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onVideoToolboxAreaClicked) && _unref(onVideoToolboxAreaClicked)(...args)))
          }, [
            _createElementVNode("div", {
              class: "tool-icon-wrap",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(enterFullScreen) && _unref(enterFullScreen)(...args)))
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "tool fas fa-search-plus fullscreen" }, null, -1)
            ]))]),
            (__props.isDownloadingScreenshot)
              ? (_openBlock(), _createElementBlock("i", _hoisted_3))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "tool-icon-wrap",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(takeScreenshot) && _unref(takeScreenshot)(...args)))
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "tool fas fa-camera dl-image" }, null, -1),
                  _createElementVNode("i", { class: "fa fa-arrow-alt-circle-down mini-arrow" }, null, -1)
                ]))])),
            (__props.isDownloadingMovieFile)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4))
              : (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "tool-icon-wrap",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(tryDownload) && _unref(tryDownload)(...args)))
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "tool fas fa-file-video dl-video" }, null, -1),
                  _createElementVNode("i", { class: "fa fa-arrow-alt-circle-down mini-arrow" }, null, -1)
                ]))]))
          ]))
        : _createCommentVNode("", true)
    ], 32),
    _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
      [_vShow, !__props.isCurrentMovieReady]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
      [_vShow, __props.isCurrentMovieReady && !_unref(state).isActiveVjsId]
    ]),
    (_unref(shouldShowPostPlayView))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "overlay1" }, null, -1)),
          (__props.isFront)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "spacer spacer-top" }, null, -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: "play-continued-btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(playContinuedMovies) && _unref(playContinuedMovies)(...args)))
                  }, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1),
                    _createElementVNode("span", { class: "ib" }, "続きを再生する", -1)
                  ]))])
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "spacer spacer-bottom" }, null, -1))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})